import React, { useState, useMemo } from 'react';
import ReactPaginate from "react-paginate";
import { Badge } from 'react-bootstrap';
//Utils 
import { RenderIf } from '../../utils/RenderIf';
import { formatDateTime } from '../../utils/formatDate';

const ReportTable = ({ table_name, table_data, table_headers, table_type, handleShowModalDetail, setSelectedInformZ, getInformZById, downloadReport }) => {
    //States
    const [searchTerm, setSearchTerm] = useState('');
    const [dataPage, setDataPagePage] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(5); // Items per page

    let infoDataPerPage = 5;

    //Function to populate the table headers
    const tableHeaders = () => {
        const headers = table_headers.map((header) => (
            <>
                <th>{header}</th>
            </>
        ));
        return headers;
    }
    //Pagination
    const handlePageChange = ({ selected }) => {
        setDataPagePage(selected);
    };

    //Filter the data by the term searched 
    const filteredData = useMemo(() => {
        if (searchTerm === '') {
            return table_data
        }
        return table_data.filter(data => {
            //We check the type of table 
            if (table_type === "general_report") {
                const transactionMatch = data.transaction_code.toString().toLowerCase().includes(searchTerm.toLocaleLowerCase());
                const dateMatch = data.createdAt.toLowerCase().includes(searchTerm.toLowerCase());
                return transactionMatch || dateMatch
            } else if (table_type === "paymentmethod_report") {
                const transactionMatch = data.transaction_code.toString().toLowerCase().includes(searchTerm.toLocaleLowerCase());
                const dateMatch = data.createdAt.toLowerCase().includes(searchTerm.toLowerCase());
                const paymentmethodMatch = data.paymenthod.toLowerCase().includes(searchTerm.toLocaleLowerCase());

                return transactionMatch || dateMatch || paymentmethodMatch
            } else if (table_type === "products_report") {
                const productMatch = data.group_name.toLowerCase().includes(searchTerm.toLocaleLowerCase());
                const totalAmountProductMatch = data.total_amount_selled.toString().toLowerCase().includes(searchTerm.toLocaleLowerCase());
                return productMatch || totalAmountProductMatch
            } else if (table_type === "inventory_report") {
                const productMatch = data.group_name.toLowerCase().includes(searchTerm.toLocaleLowerCase());
                return productMatch
            } else if (table_type === "movements_report") {
                //const reasonMatch = data.reason.toLowerCase().includes(searchTerm.toLocaleLowerCase());
                const movement_typeMatch = data.movement_type.toLowerCase().includes(searchTerm.toLocaleLowerCase());
                const productMatch = data.group_name.toLowerCase().includes(searchTerm.toLocaleLowerCase());
                const condition_movement = data.condition_movement.toLowerCase().includes(searchTerm.toLocaleLowerCase());
                return productMatch || movement_typeMatch || condition_movement
            } else if (table_type === "returns_report") {
                const transactionMatch = data.transaction_code.toString().toLowerCase().includes(searchTerm.toLocaleLowerCase());
                const dateMatch = data.createdAt.toLowerCase().includes(searchTerm.toLowerCase());
                const userMatch = data.user.name.toLowerCase().includes(searchTerm.toLocaleLowerCase());
                return transactionMatch || dateMatch || userMatch
            } else if (table_type === "tips_report") {
                const transactionMatch = data.transaction_code.toString().toLowerCase().includes(searchTerm.toLocaleLowerCase());
                const dateMatch = data.createdAt.toLowerCase().includes(searchTerm.toLowerCase());
                return transactionMatch || dateMatch
            } else if (table_type === "informz_report") {
                const dateMatch = data.createdAt.toLowerCase().includes(searchTerm.toLowerCase());
                const code = data.code.toString().toLowerCase().includes(searchTerm.toLocaleLowerCase());
                return dateMatch || code
            }
        });
    }, [searchTerm, table_data]);

    //We get the data to show in the table
    let tableDataInfoPerPage = filteredData.slice(dataPage * itemsPerPage, (dataPage + 1) * itemsPerPage);
    //Function to populate the table content 
    const tableContent = () => {
        //We check the type of table to render the content of the table 
        if (table_type === "general_report") {
            //We format the date and hour of the order
            const general_sales_content = tableDataInfoPerPage.map((content) => (
                <>
                    <tr>
                        <td className='align-middle'>{content.createdAt.split('T')[0]}</td>
                        <td className='align-middle'>{content.createdAt.split('T')[1].split(':')[0] + ':' + content.createdAt.split('T')[1].split(':')[1] + ' ' + (content.createdAt.split('T')[1].split(':')[0] <= 11 ? 'AM' : 'PM')} </td>
                        <td className='align-middle'> {content.transaction_code}</td>
                        <td className="aling-middle"> {content.total_with_tips === undefined ? "$ 0.00" : "$ " + content.total_with_tips.toFixed(2)}</td>
                        <td className="aling-middle"> {content.tips === undefined ? "$ 0.00" : "$ " + content.tips.toFixed(2)}</td>
                        <td className='align-middle'> {content.total === undefined ? "$ 0.00" : "$ " + content.total.toFixed(2)}</td>
                        <td className='align-middle'> {content.tax === undefined ? "$ 0.00" : "$ " + content.tax.toFixed(2)}</td>
                        <td className='align-middle'> {content.delivery === undefined ? "$ 0.00" : content.delivery.value !== undefined ? "$ " + content.delivery.value.toFixed(2) : "$ 0.00"}</td>
                        <td className='align-middle'> {content.subtotal === undefined ? "$ 0.00" : "$ " + content.subtotal.toFixed(2)}</td>
                        <td className='align-middle'> {content.discount === undefined || content.discount === "" ? "$ 0.00" : "$ " + content.discount.toFixed(2)}</td>
                        <td className='align-middle'> {content.cufe === undefined ? "0" : content.cufe}</td>

                    </tr>
                </>
            ));

            return general_sales_content
        } else if (table_type === "paymentmethod_report") {
            //We format the date and hour of the order
            const paymentmethod_sales_content = tableDataInfoPerPage.map((content) => (
                <>
                    <tr>
                        <td className='align-middle'>{content.createdAt.split('T')[0]}</td>
                        <td className='align-middle'>{content.createdAt.split('T')[1].split(':')[0] + ':' + content.createdAt.split('T')[1].split(':')[1] + ' ' + (content.createdAt.split('T')[1].split(':')[0] <= 11 ? 'AM' : 'PM')} </td>
                        <td className='align-middle'> {content.transaction_code}</td>
                        <td className='aling-middle'>{content.paymenthod}</td>
                        <td className="aling-middle"> {content.total_with_tips === undefined ? "$ 0.00" : "$ " + content.total_with_tips.toFixed(2)}</td>
                        <td className="aling-middle"> {content.tips === undefined ? "$ 0.00" : "$ " + content.tips.toFixed(2)}</td>
                        <td className='align-middle'> {content.total === undefined ? "$ 0.00" : "$ " + content.total.toFixed(2)}</td>
                        <td className='align-middle'> {content.subtotal === undefined ? "$ 0.00" : "$ " + content.subtotal.toFixed(2)}</td>
                        <td className='align-middle'> {content.tax === undefined ? "$ 0.00" : "$ " + content.tax.toFixed(2)}</td>
                        <td className='align-middle'> {content.discount === undefined ? "$ 0.00" : "$ " + content.discount.toFixed(2)}</td>
                        <td className='align-middle'> {content.cufe === undefined ? "0" : content.cufe}</td>
                    </tr>
                </>
            ));

            return paymentmethod_sales_content
        } else if (table_type === "products_report") {
            const product_sales_content = tableDataInfoPerPage.map((content) => (
                <>
                    <tr>
                        <td className='align-middle'>{content.group_name}</td>
                        <td className='align-middle'>{content.total_amount_selled === undefined ? "0" : content.total_amount_selled}</td>
                        <td className='align-middle'>{content.total_selled === undefined ? "$ 0.00" : '$ ' + content.total_selled.toFixed(2)}</td>

                    </tr>
                </>
            ));

            return product_sales_content
        } else if (table_type === 'preaccount_report') {
            //We format the date and hour of the order
            const preaccount_report = tableDataInfoPerPage.map((content) => (
                <>
                    <tr>
                        <td className='align-middle'>{content.createdAt.split('T')[0]}</td>
                        <td className='align-middle'>{content.createdAt.split('T')[1].split(':')[0] + ':' + content.createdAt.split('T')[1].split(':')[1] + ' ' + (content.createdAt.split('T')[1].split(':')[0] <= 11 ? 'AM' : 'PM')} </td>
                        <td className='align-middle'> {content.code}</td>
                        <td className='align-middle'> {content.total === undefined ? "$ 0.00" : "$ " + parseFloat(content.total).toFixed(2)}</td>
                        <td className='align-middle'> {content.subtotal === undefined ? "$ 0.00" : "$ " + parseFloat(content.subtotal).toFixed(2)}</td>
                        <td className='align-middle'> {content.tax === undefined ? "$ 0.00" : "$ " + parseFloat(content.tax).toFixed(2)}</td>
                        <td className='align-middle'> {content.discount === undefined ? "$ 0.00" : "$ " + parseFloat(content.discount).toFixed(2)}</td>

                    </tr>
                </>
            ));
            return preaccount_report
        } else if (table_type === 'discount_report') {
            //We format the date and hour of the order
            const discount_report = tableDataInfoPerPage.map((content) => (
                <>
                    <tr>
                        <td className='align-middle'>{content.createdAt.split('T')[0]}</td>
                        <td className='align-middle'>{content.createdAt.split('T')[1].split(':')[0] + ':' + content.createdAt.split('T')[1].split(':')[1] + ' ' + (content.createdAt.split('T')[1].split(':')[0] <= 11 ? 'AM' : 'PM')} </td>
                        <td className='align-middle'> {content.transaction_code}</td>
                        <td className='align-middle'> {content.total === undefined ? "$ 0.00" : "$ " + content.total.toFixed(2)}</td>
                        <td className='align-middle'> {content.approvedby === undefined ? "No registrado" : content.approvedby}</td>
                        <td className='align-middle'> {content.user === null && content.client === null ? "Cliente generico" : content.user === null && content.client !== null ? content.client : content.user !== null && content.client === null ? content.user : 'Cliente generico'}</td>
                    </tr>
                </>
            ));
            return discount_report
        } else if (table_type === 'returns_report') {
            //We format the date and hour of the order
            const returns_report = tableDataInfoPerPage.map((content) => (
                <>
                    <tr>
                        <td className='align-middle'>{content.createdAt.split('T')[0]}</td>
                        <td className='align-middle'>{content.createdAt.split('T')[1].split(':')[0] + ':' + content.createdAt.split('T')[1].split(':')[1] + ' ' + (content.createdAt.split('T')[1].split(':')[0] <= 11 ? 'AM' : 'PM')} </td>
                        <td className='align-middle'> {content.transaction_code}</td>
                        <td className='align-middle'> {content.total === undefined ? "$ 0.00" : "$ " + content.total.toFixed(2)}</td>
                        <td className='align-middle'> {content.user.name === undefined || content.user.name === "0" ? "No registrado" : content.user.name}</td>
                        <td className='align-middle'> {content.devolution_order_reference === undefined || content.devolution_order_reference.approved_by === undefined || content.devolution_order_reference.approved_by.name === undefined ? "No registrado" : content.devolution_order_reference.approved_by.name}</td>
                    </tr>
                </>
            ));
            return returns_report
        } else if (table_type === "tips_report") {
            //We format the date and hour of the order
            const tips_report = tableDataInfoPerPage.map((content) => (
                <>
                    <tr>
                        <td className='align-middle'>{content.createdAt.split('T')[0]}</td>
                        <td className='align-middle'>{content.createdAt.split('T')[1].split(':')[0] + ':' + content.createdAt.split('T')[1].split(':')[1] + ' ' + (content.createdAt.split('T')[1].split(':')[0] <= 11 ? 'AM' : 'PM')} </td>
                        <td className='align-middle'> {content.transaction_code}</td>
                        <td className='align-middle'> {content.total === undefined ? "$ 0.00" : "$ " + content.total.toFixed(2)}</td>
                        <td className='align-middle'> {content.tips === undefined ? "$ 0.00" : "$ " + content.tips.toFixed(2)}</td>
                    </tr>
                </>
            ));
            return tips_report
        } else if (table_type === 'inventory_report') {
            //We format the date and hour of the order
            const inventory_report = tableDataInfoPerPage.map((content) => (
                <>
                    <tr>

                        <td className='align-middle'> {content.group_name}</td>
                        <td className='align-middle'> {content.quantity}</td>
                    </tr>
                </>
            ));
            return inventory_report
        } else if (table_type === 'movements_report') {
            //We format the date and hour of the order
            const inventory_report = tableDataInfoPerPage.map((content) => (
                <>
                    <tr>
                        <td className='align-middle'> {content.group_name}</td>
                        <td className='align-middle'> {content.quantity}</td>
                        <td className='align-middle'> {content.movement_type === "exit" ? "Salida" : content.movement_type === "entry" ? "Entrada" : content.movement_type === "transfer" ? "Transferencia" : content.movement_type}</td>
                        <td className='align-middle' style={{
                            maxWidth: '220px',        // Limita el ancho máximo
                            whiteSpace: 'pre-line',   // Permite saltos de línea (\n)
                            wordBreak: 'break-word',  // Rompe palabras largas
                        }}> {
                                content.reason === "Inventory received" && content.movement_status == null && content.movement_type === "entry" ?
                                    "Entrada de inventario manual"
                                    : content.reason === "Inventory transferred" && content.movement_status == "approved" && content.movement_type === "transfer" ?
                                        "Solicitud de transferencia aprobada" :
                                        content.reason === "Inventory transferred" && content.movement_status == "rejected" && content.movement_type === "transfer" ?
                                            "Solicitud de transferencia rechazada" :
                                            content.reason === "Inventory transferred" && content.movement_status == "pending" && content.movement_type === "transfer" ?
                                                "Transferencia creada, pendiente por revisar " :
                                                content.reason === "Inventory transferred" && content.movement_status == null && content.movement_type === "exit" ?
                                                    "Salida de inventario por transferencia" :
                                                    content.reason === "Inventory transferred" && content.movement_status == null && content.movement_type === "entry" ?
                                                        "Entrada de inventario por transferencia" :
                                                        content.reason
                            }</td>
                        <td className='align-middle'> {content.note == null ? <>Vacio</> : <>{content.note}</>}</td>
                        <td className='align-middle'> {content.source_warehouse_name}</td>
                        <td className='align-middle'> {content.destination_warehouse_name}</td>
                        <td className='align-middle'> {content.user_name}</td>
                        <td className='align-middle'> {formatDateTime(content.created_at)}</td>
                    </tr>
                </>
            ));
            return inventory_report
        } else if (table_type === 'informz_report') {
            //We format the date and hour of the order
            const informz_report = tableDataInfoPerPage.map((content) => (
                <>
                    <tr>
                        <td className='align-middle'>{content.createdAt.split('T')[0]}</td>
                        <td className='align-middle'>{content.createdAt.split('T')[1].split(':')[0] + ':' + content.createdAt.split('T')[1].split(':')[1] + ' ' + (content.createdAt.split('T')[1].split(':')[0] <= 11 ? 'AM' : 'PM')} </td>
                        <td className='align-middle'> {content.code}</td>
                        <td className='align-middle'> {
                            <button
                                className='btn btn-primary border-0'
                                onClick={() => { handleShowModalDetail(); setSelectedInformZ(content); getInformZById(content._id) }}
                            >
                                <i className={'uil uil-eye'}></i>
                            </button>
                        }</td>
                    </tr>
                </>
            ));
            return informz_report
        }
    }

    return (
        <>
            {/**Tabla de detalles */}
            <div className='bg-white my-5 '>
                <div className="d-flex justify-content-between align-items-center">
                    <h5 className="fw-bold text-primary">{table_name}</h5>
                    <div className="mt-1">

                        <div className="row  g-3 align-content-center align-items-center">
                            <RenderIf isTrue={table_type === "inventory_report" || table_type === "movements_report"}>
                                <div className="col-auto">
                                    <button onClick={() => downloadReport()}
                                        className="btn btn-outline-success">
                                        <i className="fa-solid fa-file-excel me-2"></i>
                                        Descargar Excel
                                    </button>
                                </div>
                            </RenderIf>

                            {/* Selector de resultados por página */}
                            <div className="col-auto">
                                <span className='mb-0 text-secondary fw-bold'>Resultados por página</span>
                            </div>
                            <div className="col-auto">
                                <select
                                    className="form-select"
                                    value={itemsPerPage}
                                    onChange={(e) => {
                                        setItemsPerPage(Number(e.target.value)); // Update items per page
                                        setDataPagePage(0); // Reset to first page
                                    }}
                                >
                                    <option value={5}>5</option>
                                    <option value={10}>10</option>
                                    <option value={25}>25</option>
                                    <option value={50}>50</option>
                                </select>
                            </div>

                            <div className="col-auto">
                                <span className='mb-0 text-secondary fw-bold' >Buscar</span>
                            </div>
                            <div className="col-auto">
                                <input
                                    spellcheck="false"
                                    className="form-control"
                                    type="text"
                                    step="any"
                                    placeholder="Ingrese termino"
                                    onChange={e => {
                                        setSearchTerm(e.target.value);
                                        setDataPagePage(0); // Reset to first page when searching
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className=" mt-3 pb-4">
                    <div className=" border rounded table-responsive">
                        <table className='table table-hover table-sm' >
                            <thead className='table-dark'>
                                <tr>
                                    {tableHeaders()}
                                </tr>
                            </thead>
                            <tbody>
                                {tableContent()}
                            </tbody>
                        </table>
                        <ReactPaginate
                            previousLabel={"Anterior"}
                            nextLabel={"Siguiente"}
                            pageClassName="page-item"
                            pageLinkClassName="page-link"
                            previousClassName="page-item"
                            previousLinkClassName="page-link"
                            nextClassName="page-item"
                            nextLinkClassName="page-link"
                            breakLabel="..."
                            breakClassName="page-item"
                            breakLinkClassName="page-link"
                            pageCount={Math.ceil(filteredData.length / itemsPerPage)}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={handlePageChange}
                            containerClassName="pagination"
                            activeClassName="active"
                        />
                    </div>
                </div>
            </div>
        </>
    );
}

export default ReportTable;
